<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">Voucher Administration</b-navbar-brand>
			<b-collapse id="nav-collapse-sub" is-nav>
				<b-navbar-nav>
					<a href="#" v-b-modal.modal-report @click="getReport()">Reporting</a>
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
	<div id="content">


		<b-modal size="xl" id="modal-report" title="Vouchers Summary">
			<div class="row" v-if="discountReport && paymentReport">
				<div class="col-md-6">
					<div class="actions-card">
						<h4>Discounts</h4>
						<p>Total Vouchers Available: {{ discountReport.totalVouchersAvailable }}</p>
						<p>Total Vouchers Purchased: {{ discountReport.totalVouchersPurchased }}</p>
						<p>Sum Of Purchased Vouchers Value: £{{ discountReport.sumOfPurchasedVouchersValue }}</p>
						<p>Liability: £{{ discountReport.liability }}</p>
						<p>Float Balance: £{{ discountReport.floatBalance }}</p>

					</div>
				</div>

				<div class="col-md-6">
					<div class="actions-card">
						<h4>Payments</h4>
						<p>Total Payments Paid: {{ paymentReport.totalPaymentsPaid }}</p>
						<p>Total Amount Paid: £{{ paymentReport.totalAmountInPencePaid / 100 }}</p>
						<p>Total Fees Paid: £{{ paymentReport.totalFeesInPencePaid / 100 }}</p>
						<p>Total Payments Unpaid: {{ paymentReport.totalPaymentsUnpaid }}</p>
						<p>Total Amount Unpaid: £{{ paymentReport.totalAmountInPenceUnpaid / 100 }}</p>
						<p>Total Fees Unpaid: £{{ paymentReport.totalFeesInPenceUnpaid / 100 }}</p>
					</div>
				</div>
			</div>
		</b-modal>

		<b-modal id="modMessage" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="Admin">
			<p class="my-4">{{message}}</p>
		</b-modal>

		<div class="row">
			<div class="col-md-3 mb-4" v-if="vouchers">
				<b-form-input placeholder="search" class="mb-2" v-model="search"></b-form-input>
				<small>{{vouchers.length}} Vouchers</small>
				<div class="leftSide">
					<b-table striped hover :filter="search" :items="vouchers" :fields="[{key: 'merchant.name', label: 'Voucher'}, 'enabled', 'removed']" selectable select-mode="single" @row-clicked="selectVoucher">
						<template #cell(merchant.logoUrl)="data">
							<img :src="data.item.merchant.logoUrl" alt="Merchant Logo" class="img-fluid small-logo"/>
						</template>
					</b-table>
				</div>
			</div>
			<div class="col-md-9" v-if="voucher">
				<div class="m-5 mt-0">
					<h2>{{voucher.merchant.name}}</h2>
					<div class="mb-2"><small>ID: {{voucher.id}}</small></div>
					<div class="row">
						<div class="col-md-6">
							Name: <b-form-input class="mb-2" v-model="voucher.merchant.name" disabled></b-form-input>
						</div>
						<div class="col-md-6">
							Slug: <b-form-input class="mb-2" v-model="voucher.merchant.slug" disabled></b-form-input>
						</div>
					</div>
					<div class="row">
						<div class="col-md-2">
							Merchant: <b-form-select v-model="voucher.merchant.sysoMerchantId" @change="saveVoucher">
								<b-form-select-option :value="null">None</b-form-select-option>
								<b-form-select-option v-for="merchant in merchants" :key="merchant.id" :value="merchant.id">
									{{ merchant.name }}
								</b-form-select-option>
							</b-form-select>
						</div>
						<div class="col-md-4">
							Categories: <b-form-input class="mb-2" v-model="voucher.merchant.categories" @change="saveVoucher"></b-form-input>
						</div>
						<div class="col-md-1">
							Ena. <b-form-checkbox class="mb-2" v-model="voucher.enabled" :disabled="voucher.removed" @change="saveVoucher"></b-form-checkbox>
						</div>
						<div class="col-md-1">
							Rem. <b-form-checkbox class="mb-2" v-model="voucher.removed" disabled></b-form-checkbox>
						</div>
						<div class="col-md-1">
							Ftr. <b-form-checkbox class="mb-2" v-model="voucher.featured" @change="saveVoucher"></b-form-checkbox>
						</div>
						<div class="col-md-1">
							Overridden: <b-form-checkbox class="mb-2" v-model="voucher.manualOverride" @change="saveVoucher"></b-form-checkbox>
						</div>
					</div>
					<div class="row">
						<div class="col-md-6">
							Description: <b-form-textarea class="mb-2" v-model="voucher.description" disabled></b-form-textarea>
						</div>
						<div class="col-md-6">
							Terms: <b-form-textarea class="mb-2" v-model="voucher.terms" disabled></b-form-textarea>
						</div>
					</div>
					<div class="row">
						<div class="col-md-4">
							Lower Amount: <b-form-input class="mb-2" v-model="voucher.lowerAmount" disabled></b-form-input>
						</div>
						<div class="col-md-4">
							Upper Amount: <b-form-input class="mb-2" v-model="voucher.upperAmount" disabled></b-form-input>
						</div>
						<div class="col-md-4">
							Allowed Amounts: <b-form-input class="mb-2" v-model="voucher.allowedAmounts" disabled></b-form-input>
						</div>
					</div>
					<div class="row">
						<div class="col-md-4">
							In Store: <b-form-input class="mb-2" v-model="voucher.inStore" disabled></b-form-input>
						</div>
						<div class="col-md-4">
							Online: <b-form-input class="mb-2" v-model="voucher.online" disabled></b-form-input>
						</div>
						<div class="col-md-4">
							Discount Percentage: <b-form-input class="mb-2" v-model="voucher.discountPercentage" :disabled="!voucher.manualOverride" @change="saveVoucher"></b-form-input>
						</div>
					</div>
					<div class="row">
						<div class="col-md-4">
							Card URL: <b-form-input class="mb-2" v-model="voucher.cardUrl" disabled></b-form-input>
						</div>
						<div class="col-md-4">
							LogoUrl: <b-form-input class="mb-2" v-model="voucher.merchant.logoUrl" disabled></b-form-input>
						</div>
						<div class="col-md-4">
							Card Colour:
							<div class="d-flex align-items-center">
								<b-form-input
									@change="saveVoucher"
									class="mb-2 mr-2"
									type="color"
									v-model="voucher.cardColour"
									style="width: 50px; height: 38px; padding: 0; border: none; background: none;"
								/>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-4">
							<img :src="voucher.cardUrl" alt="Card Logo" class="img-fluid mb-2 small-card"/>
						</div>
						<div class="col-md-4">
							<img :src="voucher.merchant.logoUrl" alt="Merchant Logo" class="img-fluid mb-2 small-card"/>
						</div>
						<div class="col-md-4">
							<div v-if="voucher.cardColour" :style="{ backgroundColor: voucher.cardColour, width: '150px', height: '100px', borderRadius: '8px', border: '1px solid #ccc' }"></div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-4">
							Delivery Method: <b-form-input class="mb-2" v-model="voucher.deliveryMethod" disabled></b-form-input>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script>
export default {
  name: 'Vouchers',
  data() {
	return{
		vouchers: null,
		voucher: null,
		message: '',
		error: null,
		search: "",
		paymentReport: null,
		discountReport: null,
		merchants: [],
		cardColourDefault: '#ffffff',
	}
  },
  methods: {
	getMerchants: function(){
		this.$http.get(this.$config.ApiUri + "/Merchants")
			.then((result) => {
				this.merchants = result.data;
			}
		)
	},
	getVouchers: function(autoSelect){
		this.$http.get(this.$config.ApiUri + "/Discounts?all=true")
			.then((result) => {
				this.vouchers = result.data;
				if (autoSelect) {
					if (this.vouchers.length > 0) {
						this.selectVoucher(this.vouchers[0]);
					}
				}
			}
		)
	},
	selectVoucher: function(v) {
		this.voucher = v;
	},
	saveVoucher: function(){
		this.$http.put(this.$config.ApiUri + "/Discounts/" + this.voucher.id, this.voucher)
			.then((result) => {
				this.voucher = result.data;
				this.getVouchers(false);
			}
		).catch(() => { this.showError(); });
	},
	getReport() {
		console.log("getReport");
		this.$http.get(this.$config.ApiUri + "/Discounts/Reports/Summary")
			.then((result) => {
				this.discountReport = result.data;
			}
		)
		this.$http.get(this.$config.ApiUri + "/Payments/Reports/Summary")
			.then((result) => {
				this.paymentReport = result.data;
			}
		)	
	},
	showMessage(message) {
		this.message = message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	showError(message) {
		if (!message) { message = "Sorry, that didn't work, please contact Tris"; }
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	onLoad() {
		this.getVouchers(true);
		this.getMerchants();
	},
  },
  mounted: function() { this.onLoad(); }
}
</script>

<style>
.small-logo {
    max-width: 30px;
    max-height: 30px;
}
.small-card {
    max-width: 100px;
    max-height: 100px;
}
.leftSide {
    max-width: 100%;
	height: 600px;
	overflow: scroll;
    overflow-x: auto;
}
.filters
{
	margin-bottom: 10px;
	width: 100%;
}

.filters .btn-group
{
	width: 100%;
}

.modal-header .close {
  display:none;
}
#criteria .btn-sm {
	margin:3px;
	font-size:10px;
}
.actions-card {
	padding: 20px;
	margin-bottom: 10px;
	background-color:aliceblue;
}
</style>